/** Rol de administrador de inversores en el listado back-office (API / SSO). */
export const ADMIN_INVESTOR_ROLE = 'admin-investor';

export function hasSsoUserId( row: { ssoUserId?: string | null } ): boolean {
  const v = row.ssoUserId;
  return v != null && String( v ).trim() !== '';
}

type InvestorUserRow = {
  credentialState?: number;
  ssoUserId?: string | null;
};

/** Contacto con usuario de inversor vía SSO (credentialState creado + UUID SSO). */
export function hasInvestorUser( row: InvestorUserRow ): boolean {
  return row.credentialState === 1 && hasSsoUserId( row );
}

export function isAdminInvestor( row: { roles?: string[] | null } ): boolean {
  return Array.isArray( row.roles ) && row.roles.includes( ADMIN_INVESTOR_ROLE );
}
